const commonMixin = {
  mounted () {
    if (this.$route.path.indexOf('promo/') > 0 ) return // 기존 이벤트 페이지 로딩시는 사용하지 않음

    // 마우스 이벤트 제어
    this.checkPreventPrivacyEvent()
  },
  beforeDestroy () {
    document.oncontextmenu = null
    document.onmousedown = null
    document.oncopy = null
    document.onkeydown = null
  },
  methods: {
    checkPreventPrivacyEvent () {
      /* TODO : 배포한달전 주석풀고 기능 체크할것 */
      var isPrivacyPage = false
      var targetEle = document.getElementById('preventBody') || document.getElementById('preventDiv')
      if ((targetEle != null) && document.getElementById('noPreventDiv') === null) { // noPreventDiv 추가.
        isPrivacyPage = true
      }

      document.oncontextmenu = function () { // 우클릭 방지
        if (isPrivacyPage) {
          event.preventDefault()
          event.returnValue = false
        } else {
          event.returnValue = true
        }
      }
      document.onmousedown = function () { // 드래그 방지
        if (isPrivacyPage) {
          document.activeElement.blur() // 활성화(focus) 엘리먼트를 blur
          event.preventDefault()
          event.returnValue = false
        } else {
          event.returnValue = true
        }
      }

      document.oncopy = function () { // 복사 방지
        var copyallow = 'false'

        if (!_.isEmpty(targetEle) && !_.isEmpty(targetEle.dataset) && !_.isEmpty(targetEle.dataset.copyAllow)) {
          copyallow = targetEle.dataset.copyAllow
        }

        if (isPrivacyPage && copyallow !== 'true') { // 복사방지시 불필요시 data-copy-allow=true
          event.preventDefault()
          event.returnValue = false
        } else {
          event.returnValue = true
        }
      }

      document.onkeydown = function () {
        // 컨트롤 + a (전체선택)
        if (event.ctrlKey && event.keyCode === 65) {
          if (isPrivacyPage) {
            event.preventDefault()
            event.returnValue = false
          } else {
            event.returnValue = true
          }
        }
      }
      /* */
    },
    setNumberCommas (data) {
      var returnData = ''
      if (typeof data !== 'undefined' && data !== '' && data !== null && data !== 'null') {
        data = data + ''
        returnData = data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return returnData
    }
  }
}
export default commonMixin



// WEBPACK FOOTER //
// ./src/mixin/commonMixin.js